import { createContext } from 'react';
export const RecommendationContext = createContext({
    productGroupRecommendation: false,
    isRec: false,
});
//# sourceMappingURL=RecommendationContext.js.map